import { get, post, remove } from './request';

export interface CreatePreAnalysisRequest {
  cpf: string;
  name: string;
  rentValue: number;
  condominiumFee?: number;
  taxesValue?: number;
  energyBill?: number;
  waterBill?: number;
  gasBill?: number;
  estateId: string;
}

export interface PreAnalysisResponse {
  id: string;
  cpf: string;
  name?: string;
  rentValue: number;
  condominiumFee: number;
  taxesValue: number;
  energyBill: number;
  waterBill: number;
  gasBill: number;
  totalCharges: number;
  approvedLimit: number;
  installmentValue: number;
  status: 'pending' | 'approved' | 'rejected' | 'converted';
  userId: string;
  estateId: string;
  brokerId: string;
  convertedBondInsuranceId?: string;
  createdAt: string;
  updatedAt: string;
  estate?: {
    id: string;
    name: string;
  };
}

export const createPreAnalysis = async (
  data: CreatePreAnalysisRequest
): Promise<PreAnalysisResponse> => {
  return await post('/bond-insurance-pre-analysis', data);
};

export const getPreAnalyses = async (): Promise<PreAnalysisResponse[]> => {
  return await get('/bond-insurance-pre-analysis');
};

export const getPreAnalysis = async (id: string): Promise<PreAnalysisResponse> => {
  return await get(`/bond-insurance-pre-analysis/${id}`);
};

export const deletePreAnalysis = async (id: string): Promise<void> => {
  return await remove(`/bond-insurance-pre-analysis/${id}`);
};

// Interface for conversion request
export interface SolidaryTenantData {
  cpf: string;
  name: string;
  motherName?: string;
  gender?: string;
  birthDate?: string;
  civilState?: string;
  nationality?: string;
  email?: string;
  cellphone?: string;
  isResident?: boolean;
  employmentRelationship?: string;
  profession?: string;
  monthlyIncome?: number;
  otherIncome?: number;
}

export interface PropertyData {
  zipCode: string;
  street: string;
  number?: string;
  complement?: string;
  district?: string;
  city: string;
  state: string;
  propertyType: string;
  rentValue: number;
  condominiumFee?: number;
  taxesValue?: number;
  energyBill?: number;
  waterBill?: number;
  gasBill?: number;
}

export interface MainTenantData {
  cpf: string;
  name: string;
  motherName?: string;
  gender?: string;
  birthDate: string;
  civilState?: string;
  nationality?: string;
  email: string;
  cellphone: string;
  hasSocialName?: boolean;
  socialName?: string;
  isPoliticallyExposed?: string;
  pepName?: string;
  pepCpf?: string;
  pepRelationship?: string;
  employmentRelationship?: string;
  profession?: string;
  monthlyIncome?: number;
  otherIncome?: number;
}

export interface ConvertPreAnalysisRequest {
  preAnalysisId: string;
  property: PropertyData;
  mainTenant: MainTenantData;
  solidaryTenants?: SolidaryTenantData[];
}

export const convertToFullAnalysis = async (
  data: ConvertPreAnalysisRequest
): Promise<{ bondInsuranceId: string }> => {
  return await post('/bond-insurance-pre-analysis/convert', data);
};

export const generateWhatsAppShareMessage = (preAnalysis: PreAnalysisResponse): string => {
  const message = `🏠 *Pré-Análise Lado Bom Seguros*

✅ Parabéns! Você foi pré-aprovado para o Seguro Fiança!

💰 Limite aprovado: R$ ${Number(preAnalysis.approvedLimit).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
📍 Valor do aluguel: R$ ${Number(preAnalysis.rentValue).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}

Conclua seu cadastro e contrate sua apólice de forma rápida e segura!`;

  return encodeURIComponent(message);
};

export const shareViaWhatsApp = (preAnalysis: PreAnalysisResponse) => {
  const message = generateWhatsAppShareMessage(preAnalysis);
  const whatsappUrl = `https://wa.me/?text=${message}`;
  window.open(whatsappUrl, '_blank');
};
